(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('groupDetailController',groupDetailController);

	groupDetailController.$inject = ['$scope','groupDetail','$rootScope','$http','$state','groupsService','contentApprovalAccessMsg','$filter','ModalService','$timeout'];
	function groupDetailController($scope,groupDetail,$rootScope,$http,$state,groupsService,contentApprovalAccessMsg,$filter,ModalService,$timeout) {
		//////////////
		//variables //
		//////////////
		$scope.tabs = 'events,blogs,galleries,discussion';
		$scope.tabRestricted = {
			'events':false,
			'blogs':false,
			'galleries':false
		};
		$scope.show_des_btn = false;

		//////////////////////
		//function bindings //
		//////////////////////
		$scope.scrollUp = scrollUp;
		$scope.joinChapter = joinChapter;
		$scope.reloadState = reloadState;
		$scope.goToSettings = goToSettings;
		$scope.goToMembers = goToMembers;
		$scope.openSendRequestModal = openSendRequestModal;

		$scope.member=$filter("asLingo")('264');
		$scope.members=$filter("asLingo")('265');
		$scope.nameEmail=$filter('asPortalLang')('Group_Input_Name_Email',"Type name or email");
		

		activate();

		function activate() {
			if(chk_restrictions(18)) $scope.tabRestricted.events = true;
			if(chk_restrictions(19)) $scope.tabRestricted.galleries = true;
			if(chk_restrictions(20)) $scope.tabRestricted.blogs = true;
			if(groupDetail.success == 1 ){
				$scope.group = groupDetail.data;
				$scope.group.limitGroupDescription = limitGroupDescription;

				$scope.checkRestrictionStr = '';
				if($scope.group.is_chapter)
					$scope.checkRestrictionStr = 'chapter';
				if($scope.group.is_group)
					$scope.checkRestrictionStr = 'group';


				buildLeaveGrpConfig();

				if(parseInt($scope.group.tag_type) !== 3) {
					$scope.tabs = 'events';
				}

				if($scope.group.attributes != undefined && typeof($scope.group.attributes.tabs) === 'string') {
					$scope.tabs = $scope.group.attributes.tabs;
				}

				var allowed = false;
				var isCoord = false;
				if($scope.group.attributes && $scope.group.attributes.coordinators != undefined && typeof($scope.group.coordinators)=='object') {
					for (var i = 0; i < $scope.group.coordinators.length; i++) {
						if($scope.group.coordinators[i].uid == $rootScope.app_data.uid) {
							isCoord = true;
							break;
						}
					}
				}
				allowed = $rootScope.app_data.same_com_log && (isCoord || $rootScope.app_data.isAdmin);
				$scope.allowed = allowed;
			}
			fetchFollowersCount();
		}

		function joinChapter(){
			if(!$scope.group.is_chapter)
				return false;
			$scope.same_location = false;
			if($scope.group.mapping && $scope.group.user_details && angular.isDefined($scope.group.user_details.current_city) && angular.isDefined($scope.group.user_details.current_city.current_city) && $scope.group.user_details.current_city.current_city!=null){
				angular.forEach($scope.group.mapping, function(value,key){
					if(value && value.data == $scope.group.user_details.current_city.current_city){
						$scope.same_location = true;
					}
				});
			}
			if($rootScope.app_data.isAdmin || ($scope.group.extra && $scope.group.extra.privacy !== "3" && $scope.same_location)){
				$http.post('./tags3step/followTag',{tid:$scope.group.id,fetchLost: 1}).success(function(res) {
					if(res.success)
						$scope.group.following = true;
				});
			} else{
				groupsService.sendChapterJoinRequest($scope.group);
			}
		}

		function buildLeaveGrpConfig() {
			$scope.leaveGroupModalConfig = {
				heading: $filter('asPortalLang')('Leave_Group_Que',"Leave Group?"),
				body: "<span class=\"font-16\">"+$filter('asPortalLang')('Leave_Group_Msg',"Do you want to leave group [DATA:groupName]?",{'groupName':'<span class=\"mdl-typography--font-medium\">'+$scope.group.name+'</span>'})+"</span>",
				buttonConfirm: $filter('asPortalLang')('Leave_Group',"Leave Group"),
				buttonCancel: $filter('asPortalLang')('Cancel',"Cancel"),
				class: {
					heading: "center-alignment padding-bottom-24",
					actions: "flexbox justify-content-center align-items-center padding-top-28 flex-dir-row-reverse",
					body: "maximize-width center-alignment"
				},
				maxWidth: '450px'
			}
		}

		function scrollUp() {
			var onlyOnce = $rootScope.$on('$stateChangeSuccess', listener);
			function listener() {
				setTimeout(function() {
				var main_header = document.getElementsByClassName('outer-header')[0];
				var tabs = document.getElementById('tabs');
				var tabsOffset = 0;
				if(tabs && tabs.offsetHeight)
					tabsOffset = tabs.offsetHeight;
				var ui_view = document.getElementById('ui-view');
				var top_scroll = ui_view.offsetTop - main_header.offsetHeight - tabsOffset;
				scrollTo(top_scroll,1000);
				}, 1000);
				onlyOnce();
			}
		}
		function fetchFollowersCount() {
			$http.post('./tags/fetchFollowersCount',{tag_id:$scope.group.id,fetchLost: 1}).success(function(res) {
				if(res.data)
					$scope.followersCount = res.data;
				else
					$scope.followersCount=0;
			});
		}

		function reloadState() {
			$state.reload();
		}

		function goToSettings() {
			if($state.current.name!='inapp.group_detail.main' && $state.current.name!='inapp.group_detail.discussion'){
				$state.go('inapp.group_detail.settings',{},{location: 'replace'});
			}
			else
				$state.go('inapp.group_detail.settings');
		}

		function goToMembers() {
			if($scope.group && $scope.group.extra && $scope.group.extra.privacy==3 && !$scope.group.following && !$rootScope.app_data.isAdmin){
			    swal({text:$filter('asPortalLang')('Group_Restrict_Msg',"This action is restricted only to the members of this group.")});
			    return;
			}
			if($state.current.name!='inapp.group_detail.main' && $state.current.name!='inapp.group_detail.discussion'){
				$state.go('inapp.group_detail.members',{},{location: 'replace'});
			}
			else
				$state.go('inapp.group_detail.members');
		}

		function openSendRequestModal() {
			if(($scope.group.is_chapter && chk_restrictions_return(54)) || ($scope.group.is_group && chk_restrictions_return(56))){
			    contentApprovalAccessMsg.showModel();
			    return;
			}
			groupsService.sendJoinRequest($scope.group);
		}
		$scope.returnLangDataCoordinator = function(coordinator) {
            if(coordinator && coordinator.name)
                return {name:coordinator.name};
            return {name:''};
        };
		$scope.returnLangDataMember = function(member) {
            if(member && member.first_name)
                return {name:member.first_name};
            return {name:''};
        };
        $scope.goToState = function(state_name,state_params) {
        	if(state_name){
        		if(!state_params)
        			$state.go('inapp.'+state_name);
        		else
        			$state.go('inapp.'+state_name,state_params);
        	}
        }

		function limitGroupDescription() {
			$timeout(function () {
			    var element = document.getElementById('group-description');
			    if (element.scrollHeight > element.clientHeight) {
			        $scope.show_des_btn = true;
			    } else {
			    	$scope.show_des_btn = false;
			    }
			});
		}

		$scope.showFullDescription = showFullDescription;
		function showFullDescription(group) {
			ModalService.showModal({
                templateUrl: './templates/modals/chapterDescriptionModal.html',
                controller: ['$scope','close', function($scope,close) {
		        	$scope.title = group.name;
		            $scope.fullText = group.attributes.about;
		            $scope.close = function() {
		                close();
		            };
		        }],
                inputs: {
                    group: group
                },
                target: document.body
            }).then(function(modal) {
                modalBackClose(modal);
            });
		};
	}

})();